import React from "react";

import * as S from "./styles";

export const Fios: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Photo1Wrapper>
          <S.CreditPhoto1>Gucci</S.CreditPhoto1>
          <S.Photo1 />
        </S.Photo1Wrapper>
        <S.Text1Wrapper>
          <S.Text>
            <p>
              Em alguns anos, adotar as últimas tendências da moda pode
              significar lutar ativamente contra o aquecimento global. Pelo
              menos é isso o que propõe a{" "}
              <a
                href="https://www.postcarbonlab.com/"
                target="_blank"
                rel="noreferrer"
              >
                Post Carbon Lab
              </a>
              , uma startup londrina que levou o prêmio Kering de
              sustentabilidade. Seus experimentos possibilitam que a indústria
              da moda tenha uma pegada de carbono negativa a partir de um
              material feito de algas marinhas que continuam vivas, realizando a
              fotossíntese e convertendo CO₂ em O₂.
            </p>
          </S.Text>
        </S.Text1Wrapper>
        <S.Photo2Wrapper>
          <S.CreditPhoto2>Post Carbon Lab</S.CreditPhoto2>
          <S.Photo2 />
        </S.Photo2Wrapper>
        <S.Wrapper>
          <S.Title>
            Fios
            <br />
            biotecnológicos
          </S.Title>
          <S.Text2Wrapper>
            <S.Text>
              <p>
                Também explorando o potencial das algas, a{" "}
                <a
                  href="https://www.algiknit.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  AlgiKnit
                </a>{" "}
                combina ciência e design para combater os efeitos nocivos da
                indústria da moda. Os fios confeccionados com kelp – um tipo de
                alga marinha – são usados em calçados, acessórios, vestuários e
                decoração. Como os fios são feitos de recursos naturais, eles se
                degradam nas condições corretas de compostagem, mas permanecem
                duráveis ​​fora dessas condições.
              </p>

              <p>
                A empresa tem como objetivo a substituição de fibras sintéticas,
                incluindo acrílico, polipropileno e poliéster, pelos seus fios
                biotecnológicos, potencializando o valor mercadológico da
                sustentabilidade.
              </p>
            </S.Text>
            <S.Text>
              <p>
                O designer Aaron Nesser utilizou o material desenvolvido pela
                AlgiKnit na criação do seu tênis{" "}
                <a
                  href="https://globalgradshow.com/project/algikicks/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Algikicks
                </a>
                , apresentado na Semana do Design de Dubai, em 2017. Elevando o
                nível da tecnologia, Aaron adaptou as algas marinhas para serem
                usadas como matéria-prima em impressoras 3D.
              </p>
            </S.Text>
          </S.Text2Wrapper>
        </S.Wrapper>
      </S.Content>
      <S.PhotosWrapper>
        <S.Background3 />
        <S.PhotoMobile3 />
        <S.Photo4 />
        <S.PhotoMobile4 />
      </S.PhotosWrapper>
    </S.Container>
  );
};
